<div class="no-wrap fade-slider-stage">
    <ng-content />
</div>